import { useCallback } from "react";
import { getSceneState } from "../../../stores/sceneStore";
import { getHistoryActions } from "../../../stores/historyStore";

export function useRunGroupedBodyAction() {
  return useCallback((action) => {
    const historyActions = getHistoryActions();
    historyActions.beginGroup(getSceneState());
    try {
      action();
    } finally {
      historyActions.endGroup(getSceneState());
    }
  }, []);
}
